import React from 'react';
import { arrayOf, string, func, shape, bool } from 'prop-types';
import Text from '../atoms/Text';
import Separator from '../atoms/Separator';
import Plus from '../atoms/icons/Plus';
import Button from '../atoms/Button';
import { nullFunction } from '../../utils/utils';

function escapeRegExp(text) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&').trim();
}

const SuggestedSkills = ({ suggestedSkills, selectedSkills, onSkillClick, inline, title }) => {
  if (suggestedSkills.length === 0) {
    return null;
  }

  const selectedSkillsRegex = selectedSkills.reduce(
    (acc, text) => (text ? [...acc, RegExp(`^${escapeRegExp(text)}$`, 'i')] : acc),
    []
  );

  const isSkillAlreadySelected = (skillText) => selectedSkillsRegex.some((regex) => regex.test(skillText));

  return (
    <>
      {title && <Text mb={2}>{title}</Text>}
      {suggestedSkills.map((skill) => (
        <Button
          key={`suggested-skill-${skill.id}-${skill.text}`}
          mb={1}
          mr={1}
          px={2}
          py="4px"
          styleType="tertiary"
          color="secondary"
          disabled={isSkillAlreadySelected(skill.text)}
          onClick={() => onSkillClick(skill)}>
          <Plus />
          {skill.text}
        </Button>
      ))}
      {!inline && <Separator mt={0} />}
    </>
  );
};

SuggestedSkills.propTypes = {
  suggestedSkills: arrayOf(
    shape({
      id: string,
      text: string
    })
  ),
  selectedSkills: arrayOf(string),
  onSkillClick: func,
  inline: bool,
  title: string
};

SuggestedSkills.defaultProps = {
  onSkillClick: nullFunction
};

export default SuggestedSkills;
